import React, {useState} from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import ReadIcon from '@mui/icons-material/MarkEmailRead';
import UnreadIcon from '@mui/icons-material/Markunread';
import { Avatar, Badge, Box, Grid, Typography } from '@mui/material';


const Transition = React.forwardRef((props, ref) => <Slide direction='down' ref={ref} {...props} />);

export const MsgReadByModal = ({msgFromUser, readByUsers}) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const clickOpenModal = () => setIsOpenModal(true);
  const clickCloseModal = () => setIsOpenModal(false);
  const filteredReadByUsers = readByUsers.filter(user => user.id !== msgFromUser);
  if (filteredReadByUsers.length === 0) return (
    <IconButton size='small' color='primary' aria-label='unread message' disabled={true}><UnreadIcon fontSize='xs'/></IconButton>
  )
  return (
    <>
    <IconButton size='small' color='primary' aria-label='read by' onClick={clickOpenModal}>
      <Tooltip title='Read by' placement='bottom'><ReadIcon fontSize='xs'/></Tooltip>
    </IconButton>
    <Dialog fullWidth={true} maxWidth='xs' open={isOpenModal} TransitionComponent={Transition} onClose={clickCloseModal} aria-describedby='read-by-dialog'>
      <DialogTitle>{'Read by'}</DialogTitle>
      <DialogContent sx={{py: 1}}>
        {filteredReadByUsers.length > 0 && filteredReadByUsers.map((usr, i) => (
          <Grid key={usr.id} container direction='row' justifyContent='flex-start' alignItems='center' spacing={0} sx={{ px: 2, py: 2, minHeight: 62 }}>
            <Tooltip title={usr.online === true ? 'Online' : usr.last_active ? 'Offline' : 'Never seen connected'} placement='bottom'>
              <Badge color={usr.online === true ? 'success' : 'error'} variant='dot' overlap='circular' anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} sx={{mr: 1}}>
                <Avatar>{usr.name.charAt(0).toUpperCase()}</Avatar>
              </Badge>
            </Tooltip>
            <Box display='inline' component='div'>
              <Typography variant='body1'>{usr.name || 'Name not found'}</Typography>
              <Typography variant='caption'>{usr.roles?.length > 0 && usr.roles.map(role => role.charAt(0).toUpperCase() + role.slice(1).toLowerCase()).join(', ')}</Typography>
            </Box>
          </Grid>
        ))}
      </DialogContent>
      <DialogActions>
        <Button variant='text' onClick={clickCloseModal}>{'Close'}</Button>
      </DialogActions>
    </Dialog>
    </>
  );
};